import React, { useEffect } from "react";
import styled from "styled-components";
import { Modal } from "antd";
import iconHeader from "../../../../assets/images/Event-2025/icon-popup-header.png";
import iconClose from "../../../../assets/images/Event-2025/icon-btn-close-popup.png";
import bg from "../../../../assets/images/Event-2025/bg-popup-rules.png";
import TextGradient from "@pages/Events/NewYearAndChristmas_2025/components/TextGradient";
import CongratulationMain from "@pages/Events/NewYearAndChristmas_2025/Congratulation/CongratulationMain";
import "../../../../pages/Events/NewYearAndChristmas_2025/Instruction/index.scss";
import { useTranslation } from "react-i18next";

export default function PopupEnfishedEvent2025({
  open,
  setOpen = () => {},
  wrapClassName = "",
}) {
  const handleCancel = () => {
    setOpen(false);
  };
  const { t } = useTranslation();

  return (
    <StyleModal
      centered
      visible={open}
      onOk={handleCancel}
      onCancel={handleCancel}
      closable={false}
      wrapClassName={wrapClassName || ""}
    >
      <div className="position-relative">
        <img src={bg} alt="" className="bg-popup" />
        <img
          src={iconClose}
          alt=""
          className="icon-close"
          onClick={handleCancel}
        />
        <div className="header-container-popup">
          <img src={iconHeader} alt="" className="icon-header-popup" />
          <div className="content-header">
            <TextGradient
              title={t("event_new_year.congrats")}
              stop={[
                { offset: "0%", color: "#FFFFFF" },
                { offset: "36%", color: "#ffffff" },
                { offset: "65%", color: "#ceb084" },
                { offset: "100%", color: "#C9913B" },
              ]}
              fontSize="40"
              height={40}
              stroke="#7F0E1B"
              isCenterItem
            />
          </div>
        </div>

        <div className="body-popup">
          <div className="event-2024-tab-rank">
            <CongratulationMain />
          </div>
        </div>
      </div>
    </StyleModal>
  );
}

const StyleModal = styled(Modal)`
  .event-2024-tab-rank .instru_rank .congratu_content {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .event-2024-tab-rank {
    height: calc(100% - 12px);
  }

  .instru_rank.congratulation {
    height: 100%;

    ::-webkit-scrollbar {
      width: 0px;
    }
  }

  .congratu_content {
    height: 100%;
    overflow-y: scroll;
  }

  .event-2024-tab-rank .congratulation {
    padding-bottom: 0;
  }

  .event-2024-tab-rank .instru_rank .congratu_content .congratu_left {
    gap: 15px;
  }

  .event-2024-tab-rank
    .instru_rank
    .congratu_content
    .congratu_left
    .congratu_left_winner_list {
    padding: 8px 15px 0;
  }

  .event-2024-tab-rank
    .instru_rank
    .congratu_content
    .congratu_left
    .congratu_left_winner_list
    .congratu_left_winner_item {
    margin-bottom: 8px;
    padding-bottom: 8px;
  }

  .event-2024-tab-rank
    .instru_rank
    .congratu_content
    .congratu_left
    .congratu_left_winner_list
    .congratu_left_winner_item:last-child {
    padding-bottom: 0;
  }

  .event-2024-tab-rank,
  .event-2024-tab-rank .instru_rank {
    background-image: inherit !important;
  }

  .bg_top_left,
  .bg_top_right {
    display: none !important;
  }

  .event-2024-tab-rank .congratulation {
    padding-left: 0;
    padding-right: 0;
  }

  .event-2024-tab-rank .instru_rank .congratu_content h4 {
    font-size: 22px;
    height: 25px;
  }

  .event-2024-tab-rank
    .instru_rank
    .congratu_content
    .congratu_left
    .congratu_left_winner_list {
    background: radial-gradient(
      64.68% 64.68% at 50% 50%,
      #f4e7cd 0%,
      #e3cda4 100%
    );
  }

  .error-number {
    display: flex;
    width: 90%;
    margin: 0 auto;
    gap: 20px;
  }

  .icon-error-full {
    width: 255px !important;
  }

  .content-footer {
    font-size: 12px;
    font-weight: 400;
    text-align: center;
    width: 90%;
    margin: 0 auto;
    padding-bottom: 22px;
    position: absolute;
    bottom: 0px;
    z-index: 20;
    left: 50%;
    line-height: 1.5;
    transform: translateX(-50%);
  }

  .icon-main-popup img {
    position: absolute;
    bottom: 35px;
    z-index: 10;
    pointer-events: none;
  }

  .icon-main-popup {
    .icon-ng,
    .icon-th {
      bottom: 140px;
    }

    .icon-ng {
      left: 0;
    }

    .icon-th {
      right: -60px;
    }
  }

  .icon-main-popup .icon-error {
    left: 50%;
    transform: translateX(-50%);
  }

  .content-action {
    position: absolute;
    left: 50%;
    top: calc(50% - 3px);
    transform: translate(-50%, -50%);
    font-size: 18px;
    color: white;
    width: 100%;
    font-weight: bold;
    filter: drop-shadow(1px 1px 1px rgba(35, 102, 33, 1))
      drop-shadow(0px 0 0 rgba(35, 102, 33, 1))
      drop-shadow(0 1px 0 rgba(35, 102, 33, 1))
      drop-shadow(0 -1px 0 rgba(35, 102, 33, 1));
  }

  .container-action {
    bottom: 88px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 13;
    width: 100%;
  }

  .btn-container-action,
  .container-action-main {
    height: 58px;
  }

  .container-action-main {
    cursor: pointer;
    width: max-content;
    margin: 0 auto;
  }

  .bg-popup {
    border-radius: 30px;
    overflow: hidden;
    height: 100%;
  }

  .body-popup {
    border-radius: 30px;
    /* border: 4px solid #9b0a0a; */
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }

  .main-footer {
    width: 100%;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    height: 100%;
    pointer-events: none;
  }

  .icon-snow-footer {
    bottom: 0;
    left: 0;
    height: 100%;
    z-index: 11;
    position: relative;
  }

  .main-content {
    filter: drop-shadow(1px 0 0 #2e2b2b) drop-shadow(-1px 0 0 #2e2b2b)
      drop-shadow(0 1px 0 #2e2b2b) drop-shadow(0 -1px 0 #2e2b2b);
    color: white;
    width: 100%;
    padding-top: 70px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 20px;
    line-height: 1.4;
    font-weight: 500;
  }

  .content-forcus {
    color: #f1e884;
  }

  .icon-close {
    position: absolute;
    right: -12px;
    z-index: 9;
    top: -12px;
    width: 42px;
    cursor: pointer;
  }

  .header-container-popup {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    max-width: calc(100% + 40px);
    width: calc(100% + 40px);
    z-index: 2;
  }

  .content-header {
    position: absolute;
    z-index: 2;
    color: white;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
  }

  .main-body {
    position: absolute;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
  }

  .btn-close-popup-event {
    color: white;
    font-size: 20px;
    position: absolute;
    z-index: 2;
    right: 10px;
    top: 3px;
    cursor: pointer;
  }

  .position-relative {
    position: relative;
  }

  .position-absolute {
    position: absolute;
  }

  .ant-modal-content {
    background-color: inherit !important;
    box-shadow: inherit !important;
    padding: 0 !important;
  }

  .ant-modal-footer {
    display: none;
  }

  .ant-modal-body {
    text-align: center;
    display: flex;
    justify-content: center;
    padding-top: 30px;
  }

  .ant-modal-close {
    right: 40px !important;

    svg {
      color: white;
    }
  }

  @media (min-width: 992px) {
    .icon-close,
    .container-action-main {
      &:hover {
        scale: 1.05;
        transition: 0.3s ease-in-out;
      }
    }
  }

  @media (max-width: 768px) {
  }

  @media (max-width: 576px) {
    .header-container-popup {
      max-width: calc(100% + 10px);
      width: calc(100% + 10px);
    }

    .icon-close {
      width: 36px;
      right: 5px;
    }

    .content-header {
      top: 20px;
    }

    .main-content {
      padding-top: 60px;
      padding-left: 15px;
      padding-right: 15px;
      font-size: 16px;
      line-height: 1.4;
      font-weight: 500;
    }

    .icon-ng {
      width: 120px;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 130px;
    }

    .btn-container-action,
    .container-action-main {
      height: 50px;
    }

    .content-action {
      font-size: 16px;
    }

    .content-footer {
      padding-bottom: 10px;
      font-size: 13px;
    }

    .icon-error-full {
      width: 180px !important;
    }
  }

  @media (max-width: 430px) {
    .content-header {
      top: 8px;

      text {
        font-size: 20px;
      }
    }

    .icon-main-popup .icon-error {
      height: 375px !important;
    }

    .container-action {
      bottom: 70px;
    }

    .content-footer {
      padding-bottom: 10px;
      font-size: 11px;
      line-height: 1.4;
    }

    /* .container-action {
      bottom: 6px;
    } */

    .btn-container-action,
    .container-action-main {
      /* height: 40px; */
      width: auto;
    }

    .icon-main-popup .icon-ng,
    .icon-main-popup .icon-th {
      bottom: 110px;
    }

    .icon-ng {
      width: 100px;
    }

    .icon-th {
      height: 160px;
    }

    .event-2024-tab-rank .instru_rank .congratu_content h4{
      font-size: 16px;
    }
  }
`;
